"use strict";

var __awaiter = this && this.__awaiter || function (thisArg, _arguments, P, generator) {
  function adopt(value) {
    return value instanceof P ? value : new P(function (resolve) {
      resolve(value);
    });
  }
  return new (P || (P = Promise))(function (resolve, reject) {
    function fulfilled(value) {
      try {
        step(generator.next(value));
      } catch (e) {
        reject(e);
      }
    }
    function rejected(value) {
      try {
        step(generator["throw"](value));
      } catch (e) {
        reject(e);
      }
    }
    function step(result) {
      result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected);
    }
    step((generator = generator.apply(thisArg, _arguments || [])).next());
  });
};
var __generator = this && this.__generator || function (thisArg, body) {
  var _ = {
      label: 0,
      sent: function () {
        if (t[0] & 1) throw t[1];
        return t[1];
      },
      trys: [],
      ops: []
    },
    f,
    y,
    t,
    g;
  return g = {
    next: verb(0),
    "throw": verb(1),
    "return": verb(2)
  }, typeof Symbol === "function" && (g[Symbol.iterator] = function () {
    return this;
  }), g;
  function verb(n) {
    return function (v) {
      return step([n, v]);
    };
  }
  function step(op) {
    if (f) throw new TypeError("Generator is already executing.");
    while (_) try {
      if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
      if (y = 0, t) op = [op[0] & 2, t.value];
      switch (op[0]) {
        case 0:
        case 1:
          t = op;
          break;
        case 4:
          _.label++;
          return {
            value: op[1],
            done: false
          };
        case 5:
          _.label++;
          y = op[1];
          op = [0];
          continue;
        case 7:
          op = _.ops.pop();
          _.trys.pop();
          continue;
        default:
          if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) {
            _ = 0;
            continue;
          }
          if (op[0] === 3 && (!t || op[1] > t[0] && op[1] < t[3])) {
            _.label = op[1];
            break;
          }
          if (op[0] === 6 && _.label < t[1]) {
            _.label = t[1];
            t = op;
            break;
          }
          if (t && _.label < t[2]) {
            _.label = t[2];
            _.ops.push(op);
            break;
          }
          if (t[2]) _.ops.pop();
          _.trys.pop();
          continue;
      }
      op = body.call(thisArg, _);
    } catch (e) {
      op = [6, e];
      y = 0;
    } finally {
      f = t = 0;
    }
    if (op[0] & 5) throw op[1];
    return {
      value: op[0] ? op[1] : void 0,
      done: true
    };
  }
};
Object.defineProperty(exports, "__esModule", {
  value: true
});
var axios_1 = require("axios");
// Login where username + password are submitted in same request
exports.login = function (username, password, baseurl, realm, tree, name) {
  return __awaiter(void 0, void 0, void 0, function () {
    var url, headers, params, callbacks, loginPayload, loginResponse;
    return __generator(this, function (_a) {
      switch (_a.label) {
        case 0:
          url = baseurl + '/' + name + '/json' + realm + '/authenticate';
          headers = {
            'Accept-API-Version': 'resource=2.0',
            'Content-Type': 'application/json'
          };
          params = {
            'authIndexType': 'service',
            'authIndexValue': tree
          };
          return [4 /*yield*/, exports.getCallbacks(url, headers, params)];
        case 1:
          callbacks = _a.sent();
          loginPayload = exports.processCallbacks(callbacks, username, password);
          return [4 /*yield*/, exports.sendLoginPayload(loginPayload, url, headers, params)];
        case 2:
          loginResponse = _a.sent();
          return [2 /*return*/, loginResponse];
      }
    });
  });
};
// Checks if username belongs to an account
exports.checkUsername = function (username, sourceApp, baseurl, realm, tree, name) {
  return __awaiter(void 0, void 0, void 0, function () {
    var url, headers, params, callbacks, loginPayload, loginResponse;
    return __generator(this, function (_a) {
      switch (_a.label) {
        case 0:
          url = baseurl + '/' + name + '/json' + realm + '/authenticate';
          headers = {
            'Accept-API-Version': 'resource=2.0',
            'Content-Type': 'application/json'
          };
          params = {
            'authIndexType': 'service',
            'authIndexValue': tree
          };
          return [4 /*yield*/, exports.getCallbacks(url, headers, params)];
        case 1:
          callbacks = _a.sent();
          loginPayload = exports.processCallbacks(callbacks, username, sourceApp);
          return [4 /*yield*/, exports.sendLoginPayload(loginPayload, url, headers, params)];
        case 2:
          loginResponse = _a.sent();
          return [2 /*return*/, loginResponse];
      }
    });
  });
};
// Checks if password is valid
exports.checkPassword = function (password, callbacks, baseurl, realm, tree, name) {
  return __awaiter(void 0, void 0, void 0, function () {
    var url, headers, params, loginPayload, loginResponse;
    return __generator(this, function (_a) {
      switch (_a.label) {
        case 0:
          url = baseurl + '/' + name + '/json' + realm + '/authenticate';
          headers = {
            'Accept-API-Version': 'resource=2.0',
            'Content-Type': 'application/json'
          };
          params = {
            'authIndexType': 'service',
            'authIndexValue': tree
          };
          loginPayload = exports.processCallbackSingle(callbacks, password);
          return [4 /*yield*/, exports.sendLoginPayload(loginPayload, url, headers, params)];
        case 1:
          loginResponse = _a.sent();
          return [2 /*return*/, loginResponse];
      }
    });
  });
};
// Makes initial request to AM to get callbacks
exports.getCallbacks = function (url, headers, params) {
  return __awaiter(void 0, void 0, void 0, function () {
    return __generator(this, function (_a) {
      switch (_a.label) {
        case 0:
          return [4 /*yield*/, axios_1.default({
            headers: headers,
            method: 'post',
            params: params,
            url: url
          }).then(function (response) {
            return {
              response: response.data,
              status: response.status
            };
          }).catch(function (err) {
            return {
              response: err.response.data,
              status: err.response.status
            };
          })];
        case 1:
          return [2 /*return*/, _a.sent()];
      }
    });
  });
};
// Checks if a token was returned with callbacks from Forgerock AM
exports.checkToken = function (callbacks) {
  try {
    var tokenId = callbacks.response.tokenId;
    return true;
  } catch (_a) {
    return false;
  }
};
// Inserts user info into callbacks provided by AM
exports.processCallbacks = function (callbacks, username, sourceApp) {
  var loginPayload = callbacks.response;
  if (callbacks.status < 299) {
    loginPayload.callbacks[0].input[0].value = username;
    loginPayload.callbacks[1].input[0].value = sourceApp;
  }
  return loginPayload;
};
// Inserts user info into callbacks provided by AM
exports.processCallbackSingle = function (callbacks, value) {
  var loginPayload = callbacks.response;
  if (callbacks.status < 299) {
    try {
      loginPayload.callbacks[0].input[0].value = value;
    } catch (_a) {
      return loginPayload;
    }
  }
  return loginPayload;
};
// Submits callbacks w user info back to AM
exports.sendLoginPayload = function (loginPayload, url, headers, params) {
  return __awaiter(void 0, void 0, void 0, function () {
    return __generator(this, function (_a) {
      switch (_a.label) {
        case 0:
          return [4 /*yield*/, axios_1.default({
            data: loginPayload,
            headers: headers,
            method: 'post',
            params: params,
            url: url
          }).then(function (response) {
            return handleSuccessResponse(response);
          }).catch(function (err) {
            return handleErrorResponse(err);
          })];
        case 1:
          return [2 /*return*/, _a.sent()];
      }
    });
  });
};
exports.parseToken = function (token) {
  var tokenDeconstructed = token.split('*');
  return {
    'jwt': tokenDeconstructed[2],
    'original': token,
    'ssoToken': tokenDeconstructed[1] + '*'
  };
};
var handleSuccessResponse = function (resp) {
  return __awaiter(void 0, void 0, void 0, function () {
    return __generator(this, function (_a) {
      return [2 /*return*/, {
        'response': resp.data,
        'status': resp.status
      }];
    });
  });
};
var handleErrorResponse = function (error) {
  if (error.response.status == 401) {
    try {
      return {
        'response': error.response.data,
        'status': error.response.status,
        'failureUrl': error.response.data.detail.failureUrl
      };
    } catch (_a) {
      return {
        'response': error.response.data,
        'status': error.response.status,
        'failureUrl': "/unknownerror"
      };
    }
  } else {
    return {
      'response': error.response.data,
      'status': error.response.status,
      'failureUrl': "/unknownerror"
    };
  }
};